import { useEffect, useState } from 'react';

import {
  fetchCanvassingSessionFilterOptions,
  toCanvassingSessionRequestError,
  type CanvassingSessionFetchImpl,
  type CanvassingSessionRequestError,
} from './canvassingSessionApi';

export type UseCanvassingSessionFilterOptionsOptions = {
  fetchImpl?: CanvassingSessionFetchImpl;
};

export type UseCanvassingSessionFilterOptionsResult = {
  canvasserIds: string[];
  loading: boolean;
  error: CanvassingSessionRequestError | null;
  refetch: () => void;
};

export const useCanvassingSessionFilterOptions = ({
  fetchImpl,
}: UseCanvassingSessionFilterOptionsOptions = {}): UseCanvassingSessionFilterOptionsResult => {
  const [canvasserIds, setCanvasserIds] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<CanvassingSessionRequestError | null>(null);
  const [refetchCounter, setRefetchCounter] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const run = async (): Promise<void> => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchCanvassingSessionFilterOptions({ fetchImpl });
        if (!cancelled) setCanvasserIds(data.canvassingSessionFilterOptions.canvasserIds);
      } catch (requestError) {
        if (!cancelled) {
          setError(toCanvassingSessionRequestError(requestError, 'Failed to load canvasser filter options.'));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    void run();

    return () => {
      cancelled = true;
    };
  }, [fetchImpl, refetchCounter]);

  return {
    canvasserIds,
    loading,
    error,
    refetch: () => setRefetchCounter(counter => counter + 1),
  };
};
